import {
  Activity,
  AlignLeft,
  BarChart2,
  Calculator,
  CheckCircle,
  Clock,
  Cpu,
  Database,
  FileText,
  Filter,
  GitBranch,
  GitMerge,
  Globe,
  Layers,
  Maximize2,
  MessageSquare,
  Mic,
  MinusCircle,
  Music,
  PauseCircle,
  PieChart,
  Repeat2,
  RotateCw,
  Search,
  Shield,
  Smile,
  Star,
  Tag,
  Target,
  TrendingDown,
  TrendingUp,
  Volume2,
  WifiOff,
  Zap,
  type LucideIcon,
} from "lucide-react"

export const METRIC_TYPE_ICONS: Record<string, LucideIcon> = {
  // LLM Judge
  "text-llm-judge": MessageSquare,
  "audio-llm-judge": Mic,
  manager_composite_evaluation: Layers,
  // Heuristics
  manager_api_state: Globe,
  manager_match_expected_sim_wrapper: Target,
  manager_metadata_field_metric: Tag,
  manager_transcript_regex_match: Search,
  manager_words_per_message_with_threshold: AlignLeft,
  manager_agent_repeats_itself: Repeat2,
  manager_custom_end_reason: CheckCircle,
  manager_custom_agent_fails_to_respond: Clock,
  manager_ivr_flow_adherence: GitBranch,
  // Customized Audio Metrics
  pause_analysis_metric: PauseCircle,
  manager_volume: Volume2,
  manager_abrupt_pitch_changes: TrendingUp,
  manager_pitch_variability: Music,
  manager_lufs: Volume2,
  manager_volume_pitch_misalignment: Activity,
  manager_non_expressive_pauses: MinusCircle,
  manager_vocal_fry: Mic,
  manager_spectrogram_pitch_analysis: BarChart2,
  manager_custom_audio_frequency: Filter,
  manager_custom_agent_needs_reprompting: Clock,
  manager_custom_audio_sentiment: Smile,
  manager_transcription_error: FileText,
  manager_speaking_time_percentage: PieChart,
  // Speech Quality
  manager_speech_artifact_anomaly: Shield,
  // Artifact Detection
  manager_clipping_artifact: Zap,
  manager_dropout_artifact: WifiOff,
  manager_codec_artifact: Cpu,
  // Speech Anomaly Detection
  manager_loop_detection: RotateCw,
  manager_phoneme_stretch: Maximize2,
  manager_syllable_rate: Activity,
  manager_voice_quality: Star,
  manager_timbre_drift: TrendingDown,
  // Rubric Decision Tree
  manager_rubric_decision_tree: GitBranch,
  // Trace Metrics
  manager_custom_trace: Activity,
  // Derived
  manager_derived_strict_logic: GitMerge,
  manager_derived_aggregate: Calculator,
  // Custom SQL
  manager_sql_float: Database,
}
